

function  umeMoreFrontend() {

        document.addEventListener('click', (ev) => {
            const matches = ev.target.matches ? ev.target.matches('.ume-more-button') : ev.target.msMatchesSelector('.ume-more-button');
            if (!matches) return;
            const button = ev.target;
            const wrapper = ev.target.parentElement;
            const hidden = wrapper.querySelector('.ume-more-inner');
            const top = wrapper.querySelector('.ume-more-inner-top');


            let trimmedButtonText = button.innerHTML.replace(/\s/g, "");

            hidden.classList.toggle('ume-more-inner__show');
            button.classList.toggle('ume-more-button__open');


            button.innerHTML = 'Weniger lesen'

            if (trimmedButtonText === 'Wenigerlesen') {
                button.innerHTML = 'Mehr lesen'
            }

            // top.scrollIntoView(true);
        })

}
export default umeMoreFrontend;